import { render, staticRenderFns } from "./UpdateMovie.vue?vue&type=template&id=2438dbd8&scoped=true"
import script from "./UpdateMovie.vue?vue&type=script&lang=js"
export * from "./UpdateMovie.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/CU_artist.css?vue&type=style&index=0&id=2438dbd8&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2438dbd8",
  null
  
)

export default component.exports